import React from "react";
import ReactDOM from "react-dom";
import Swal from "sweetalert2";
import AppButton from "../../button/app-button";
import "./confirm-alert.css";

const ConfirmAlert = ({
	title = "Confirmar ação?",
	description = "",
	confirmLabel = "Confirmar",
	cancelLabel = "Cancelar",
	onConfirm,
	onCancel
}) => {
	return (
		<div className="confirm-alert">
			<div className="confirm-alert__icon">
				<span>!</span>
			</div>

			<h2>{title}</h2>

			{description && (
				<p>{description}</p>
			)}

			<div className="confirm-alert__actions">
				<AppButton
					type="button"
					className="confirm-alert__button confirm-alert__button--confirm"
					onClick={onConfirm}
				>
					{confirmLabel}
				</AppButton>

				<AppButton
					type="button"
					className="confirm-alert__button confirm-alert__button--cancel"
					onClick={onCancel}
				>
					{cancelLabel}
				</AppButton>
			</div>
		</div>
	);
};

export const showConfirmAlert = ({
	title,
	description,
	confirmLabel = "Confirmar",
	cancelLabel = "Cancelar",
	allowOutsideClick = false
}) => {
	return Swal.fire({
		showConfirmButton: false,
		showCloseButton: false,
		allowOutsideClick,
		customClass: {
			popup: "confirm-alert__popup"
		},
		html: `<div id="confirmAlertRoot"></div>`,
		onOpen: () => {
			const root = document.getElementById("confirmAlertRoot");

			if (!root) {
				return;
			}

			ReactDOM.render(
				<ConfirmAlert
					title={title}
					description={description}
					confirmLabel={confirmLabel}
					cancelLabel={cancelLabel}
					onConfirm={() => Swal.clickConfirm()}
					onCancel={() => Swal.close()}
				/>,
				root
			);
		},
		onClose: () => {
			const root = document.getElementById("confirmAlertRoot");

			if (root) {
				ReactDOM.unmountComponentAtNode(root);
			}
		}
	});
};

export default ConfirmAlert;